import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isInsideEditor } from '@wix/da-editor-tiptap/pkg/components/utils/helpers';
import { moveNext, movePrev, exitDuperbrowse } from '../redux/actionCreators';
import { getIsDuperbrowseActive } from '../redux/selectors';

export function useDuperbrowseKeyboardNavigation(
  enableKeyboardNavigation: boolean
) {
  const isDuperbrowseActive = useSelector(getIsDuperbrowseActive);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isDuperbrowseActive || !enableKeyboardNavigation) {
      return;
    }

    const onKeyDown = (e: KeyboardEvent) => {
      const target = e.target as Element;

      if (
        // avoid interfering with any text inputs
        target &&
        (['INPUT', 'TEXTAREA'].includes(target.tagName) ||
          isInsideEditor(target) ||
          target.hasAttribute('contenteditable'))
      ) {
        return;
      }

      switch (e.key) {
        case 'ArrowRight':
          dispatch(moveNext());
          break;
        case 'ArrowLeft':
          dispatch(movePrev());
          break;
        case 'Escape':
          dispatch(exitDuperbrowse());
          break;
        default:
          return;
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isDuperbrowseActive, enableKeyboardNavigation, dispatch]);
}
